import {
  VIDEO_PLATFORMS,
  VIDEO_PLATFORM_SPECS,
  type VideoPlatform,
} from "@farzin/contracts";

const PLATFORM_ICONS: Readonly<Record<VideoPlatform, string>> = {
  tiktok: "♪",
  "youtube-shorts": "▶",
  "youtube-video": "▰",
  "instagram-story": "◫",
  "instagram-reels": "◎",
};

export interface PlatformPickerProps {
  readonly value: VideoPlatform;
  readonly onChange: (value: VideoPlatform) => void;
}

export function PlatformPicker({
  value,
  onChange,
}: PlatformPickerProps): React.JSX.Element {
  return (
    <div
      className="platform-grid"
      role="radiogroup"
      aria-label="Video platform"
    >
      {VIDEO_PLATFORMS.map((platform) => {
        const spec = VIDEO_PLATFORM_SPECS[platform];
        return (
          <button
            className={`platform-card${value === platform ? " selected" : ""}`}
            type="button"
            role="radio"
            aria-checked={value === platform}
            key={platform}
            onClick={() => onChange(platform)}
          >
            <span className="platform-icon">{PLATFORM_ICONS[platform]}</span>
            <span>
              <strong>{spec.label}</strong>
              <small>{spec.aspectRatio}</small>
            </span>
          </button>
        );
      })}
    </div>
  );
}
